// ANCHOR Model
import {
  createPropsSelectorModel, createSelector, createSelectors, createValue,
} from 'react-scoped-model';

// ANCHOR API
import { IFormSubmissionQuestions } from '@lyon/utils/api/results/forms';

// ANCHOR Utils
import { tuple } from '@lyon/utils/tuple';

interface IProps {
  data: IFormSubmissionQuestions;
}

export const FormSubmissionQuestionItem = createPropsSelectorModel<IProps>({
  displayName: 'Models.FormSubmissionQuestionItem',
});

export const useFormSubmissionQuestionItemData = createValue(
  FormSubmissionQuestionItem,
);

export const useFormSubmissionQuestionItemQuestion = createSelectors(
  FormSubmissionQuestionItem,
  ({ data }) => tuple(
    data.question.id,
    data.question.type,
  ),
);

export const useFormSubmissionQuestionItemAnswer = createSelector(
  FormSubmissionQuestionItem,
  ({ data }) => data.answers.map((answer) => {
    try {
      return decodeURI(answer)
        .replace(/_comma_/g, ',')
        .replace(/_percent_/g, '%');
    } catch {
      return answer;
    }
  }),
);

export const useFormSubmissionQuestionItemQuestionDetails = createSelector(
  FormSubmissionQuestionItem,
  ({ data }) => data.question,
);

export const useFormSubmissionQuestionItemRemark = createSelector(
  FormSubmissionQuestionItem,
  ({ data }) => data.remark,
);

export const useFormSubmissionQuestionItemQuestionId = createSelector(
  FormSubmissionQuestionItem,
  ({ data }) => data.question.id,
);

export const useFormSubmissionQuestionItemFinalScore = createSelector(
  FormSubmissionQuestionItem,
  ({ data }) => data.finalScore,
);

export const useFormSubmissionQuestionItemState = createSelector(
  FormSubmissionQuestionItem,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  ({ data }) => data.state,
);
